/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import Select from 'react-select';
import Notification from 'rc-notification';
import 'react-datepicker/dist/react-datepicker.css';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { getAdvCampaignData, handleLoader } from '../../../../redux/actions/AdvCampaignsActions';
import { tableAdvCampgains } from '../../helper';
import AdvCampgains from './AdvCampgains';
import AdvCampaignTable from './AdvCampaignTable';
import ViewNewReturnReportModel from './ViewReportModel';
import { setCurrencyFormat } from '../../../../utils/helpers';

const titleNormalColor = '#18d67f';

const AdvCampgainsIndex = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const { isLoading, advCampaignData, salesChannelFilterData } = useSelector(
    ({ advCampaignReducer, marketPlaceReducer }) => ({
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      advCampaignData: advCampaignReducer.advCampaignData,
      isLoading: advCampaignReducer.isLoading,
    }),
  );

  const [isOpen, setIsOpen] = useState(false);
  const [advCampaignDataToShow, setAdvCampaignDataToShow] = useState([]);
  const filtersObj = advCampaignData?.modal?.filters?.[0];
  const [filterData, setFilterData] = useState({});
  const [selectedCampaignOptions, setselectedCampaignOptions] = useState();
  const [dateRange, setDateRange] = useState([
    new Date(moment().subtract(1, 'month')),
    new Date(moment()),
  ]);
  const [startDate, endDate] = dateRange;

  const campaignTypeOptions = [];

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true;
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray =
        filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
        flag = false;
      }
    }

    return flag;
  };

  // eslint-disable-next-line array-callback-return
  advCampaignData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
      campaignTypeOptions.push({
        value: element.key,
        label: element.shortValue
      });
    });
  });

  const sortedCampaignTypeOptions = campaignTypeOptions.sort((a, b) => a.label > b.label ? 1 : -1)
  // eslint-disable-next-line react/prop-types
  const changeFilterForCampaignType = (value) => {
    setselectedCampaignOptions(value)
  };

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: { top: 120, fontWeight: 'bold' },
        maxCount: 10,
      });
    });
    const dvHeaderF = document.getElementById('dvHeaderFilter');
    const dvTb = document.getElementById('dvTable');
    const dvChartV = document.getElementById('dvChartView');
    dvHeaderF.style.display = 'none';
    dvTb.style.display = 'none';
    dvChartV.style.display = 'none';
    const element = container.current || document.body;

    savePDF(element, {
      paperSize: 'auto',
      Header: 'test',
      margin: { left: '1cm', top: '1cm', right: '1cm', bottom: '1cm' },
      // margin: "2cm",
      // forcePageBreak: ".page-break",
      //   landscape: true,
      //  multiPage: true,
      fileName: `Adv Campaigns Report ${new Date().getFullYear()}`,
    });
    dvHeaderF.style.display = 'block';
    dvTb.style.display = 'block';
    dvChartV.style.display = 'block';
  };

  const callApi = () => {
    dispatch(handleLoader(true));
    dispatch(
      getAdvCampaignData({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
      }),
    );
  };

  const handleApplyDate = () => {
    callApi();
  };

  const viewReportButton = () => (
    <div className="view-report" style={{ zIndex: 2, top: '-10px', right: '0px' }}>
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  );

  useEffect(() => {
    dispatch(handleLoader(true));
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setAdvCampaignDataToShow(advCampaignData?.modal?.data || []);
  }, [advCampaignData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData]);

  let advCampaignDataToShowForDatesSelected = advCampaignDataToShow
    ?.filter(item => filterBasedOnFilter(item))
    .map((item) => {
      item.impressions =
        item.impressions !== 'Infinity' && item.impressions !== 'NaN'
          ? Number(item.impressions)
          : 0;
      item.clicks = item.clicks !== 'Infinity' && item.clicks !== 'NaN' ? Number(item.clicks) : 0;
      item.orders = item.orders !== 'Infinity' && item.orders !== 'NaN' ? Number(item.orders) : 0;
      item.units = item.units !== 'Infinity' && item.units !== 'NaN' ? Number(item.units) : 0;
      item.sales = item.sales !== 'Infinity' && item.sales !== 'NaN' ? Number(item.sales) : 0;
      item.conversion =
        item.conversion !== 'Infinity' && item.conversion !== 'NaN' ? Number(item.conversion) : 0;
      item.cost = item.cost !== 'Infinity' && item.cost !== 'NaN' ? Number(item.cost) : 0;
      item.cpc = item.cpc !== 'Infinity' && item.cpc !== 'NaN' ? Number(item.cpc) : 0;
      item.ctr = item.ctr !== 'Infinity' && item.ctr !== 'NaN' ? Number(item.ctr) : 0;
      item.acos = item.acos !== 'Infinity' && item.acos !== 'NaN' ? Number(item.acos) : 0;
      item.roas = item.roas !== 'Infinity' && item.roas !== 'NaN' ? Number(item.roas) : 0;

      return item;
    });

  if (selectedCampaignOptions?.length) {
    const selected = selectedCampaignOptions?.reduce((acc, item) => {
      acc[item?.value] = item.value
      return acc
    }, {})
    advCampaignDataToShowForDatesSelected = advCampaignDataToShowForDatesSelected.
      filter(item => selected[item.campaignType])
  }
  const dataToReport = [];
  const dataByCampaignName = {};

  const statData = {
    impressionsTo: 0,
    cost: 0,
    sales: 0,
    clicks: 0,
    orders: 0,
    cpc: 0,
    ctr: 0,
    conversion: 0,
    roas: 0,
    acos: 0,
  };

  advCampaignDataToShowForDatesSelected.forEach((item) => {
    const { impressions, clicks, orders, sales, cost, campaignName } = item;

    statData.impressionsTo += Number(impressions);
    statData.cost += Number(cost);
    statData.sales += Number(sales);
    statData.clicks += Number(clicks);
    statData.orders += Number(orders);
    const key = `${campaignName}`;

    if (dataByCampaignName[key]) {
      dataByCampaignName[key].push(item);
    } else {
      dataByCampaignName[key] = [item];
    }
  });

  statData.acos = (statData.cost / (statData.sales || 1)) * 100;

  statData.roas = statData.sales / (statData.cost || 1);

  statData.ctr = (statData.clicks / (statData.impressionsTo || 1)) * 100;

  statData.conversion = (statData.orders / (statData.clicks || 1)) * 100;

  statData.cpc = statData.cost / (statData.clicks || 1);

  const dataCampaigns = Object.keys(dataByCampaignName);

  dataCampaigns.forEach((campaign) => {
    const campaignNameData = dataByCampaignName[campaign];

    const dataItem = {
      Type: '',
      State: '',
      Campaign: campaign,
      Budget: 0,
      Impressions: 0,
      Clicks: 0,
      Orders: 0,
      Units: 0,
      Sales: 0,
      Conversion: 0,
      Cost: 0,
      CPC: 0,
      CTR: 0,
      ACOS: 0,
      ROAS: 0,
      date: '',
      targettingType: '',
    };

    campaignNameData?.reduce((acc, item) => {
      const {
        budget,
        clicks,
        campaignType,
        cost,
        date,
        targettingType,
        impressions,
        orders,
        sales,
        state,
        units,
      } = item;
      acc.Type = campaignType;
      acc.State = state;
      acc.Budget += Number(budget);
      acc.Impressions += Number(impressions);
      acc.Clicks += Number(clicks);
      acc.Orders += Number(orders);
      acc.Units += Number(units);
      acc.Sales += Number(sales);
      acc.Cost += Number(cost);
      acc.date = date;
      acc.targettingType = targettingType;

      return acc;
    }, dataItem);

    dataItem.ACOS = (dataItem.Cost / (dataItem.Sales || 1)) * 100;

    dataItem.ROAS = dataItem.Sales / (dataItem.Cost || 1);

    dataItem.CTR = (dataItem.Clicks / (dataItem.Impressions || 1)) * 100;

    dataItem.Conversion = (dataItem.Orders / (dataItem.Clicks || 1)) * 100;

    dataItem.CPC = dataItem.Cost / (dataItem.Clicks || 1);

    dataToReport.push({
      ...dataItem,
    });
  });

  const excelData = dataToReport
    .sort((itemOne, itemTwo) => (Number(itemOne.Cost) < Number(itemTwo.Cost) ? 1 : -1))
    .map((item) => {
      const updated = { ...item };

      updated.Budget = setCurrencyFormat(Number(updated.Budget).toFixed(2), true);

      updated.Sales = setCurrencyFormat(Number(updated.Sales).toFixed(2), true);

      updated.Conversion = `${setCurrencyFormat(Number(updated.Conversion).toFixed(2), false)} %`;
      updated.Cost = setCurrencyFormat(Number(updated.Cost).toFixed(2), true);

      updated.CPC = setCurrencyFormat(Number(updated.CPC).toFixed(2), false);

      updated.CTR = `${setCurrencyFormat(Number(updated.CTR).toFixed(2), false)} %`;
      updated.ACOS = `${setCurrencyFormat(Number(updated.ACOS).toFixed(2), false)} %`;
      updated.ROAS = setCurrencyFormat(Number(updated.ROAS).toFixed(2), false);

      updated.Clicks = setCurrencyFormat(Number(updated.Clicks).toFixed(), false);

      updated.Impressions = setCurrencyFormat(Number(updated.Impressions).toFixed(), false);

      updated.Orders = setCurrencyFormat(Number(updated.Orders).toFixed(), false);

      updated.Units = setCurrencyFormat(Number(updated.Units).toFixed(), false);
      return updated;
    });

  return (
    <Container className="dashboard">
      <div id="divToPrint" ref={container}>
        <Row className="monthly-subscription-order">
          <Col sm="12">
            <Card className="pb-3">
              <CardBody className="min-w-50 p-3">
                <div className="card__title mb-2">
                  <h5 className="bold-text card__title-center">ADV Campaigns</h5>
                </div>
                <Row className="align-items-center" id="dvHeaderFilter">
                  <Col md="12">
                    <Row className="align-items-center">
                      <Col sm="4">
                        <div className="form__form-group mb-0">
                          <span className="form__form-group-label">Date</span>
                          <div className="form__form-group-field">
                            <div className="date-picker">
                              <DatePicker
                                dateFormat="MM/dd/yyyy"
                                selectsRange
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(update) => {
                                  setDateRange(update);
                                }}
                                withPortal={isMobileOnly}
                                value={`${moment(startDate).format('MM/DD/YYYY')} - ${endDate ? moment(endDate).format('MM/DD/YYYY') : 'Select End Date'
                                  }`}
                              />
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col sm="3" style={{ top: '10px' }}>
                        <button
                          className="btn btn-sm btn-primary apply-date-button"
                          type="button"
                          onClick={handleApplyDate}
                        >
                          Apply
                        </button>
                        <button
                          className="btn btn-sm btn-primary
                                             apply-date-button"
                          type="button"
                          title="Export to pdf"
                          disabled={isLoading}
                          onClick={exportToPDF}
                        >
                          Export PDF
                        </button>
                      </Col>
                      <Col sm="1">
                        &nbsp;
                      </Col>
                      <Col sm="3" className='align-items-right'>
                        <div className="form__form-group mb-0">
                          <span className="form__form-group-label">Filter Type</span>
                          <div className="form__form-group-field">
                            <Select
                              value={selectedCampaignOptions}
                              options={sortedCampaignTypeOptions}
                              clearable={false}
                              placeholder="Select "
                              className="select_filter-300"
                              onChange={changeFilterForCampaignType}
                              classNamePrefix="react-select"
                              isMulti
                            />
                          </div>

                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col sm="12">
            <Card className="pb-3">
              <CardBody style={{ background: isLoading ? '#fff' : 'rgb(0, 128, 128)' }}>
                {isLoading ? (
                  <div
                    style={{ minHeight: '200px' }}
                    className="row align-items-center justify-content-center"
                  >
                    <SmallLoader loading={isLoading} />
                  </div>
                ) : (
                  <>
                    <Row className="justify-content-start align-items-center">
                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            Impression
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {' '}
                            {statData?.impressionsTo &&
                              setCurrencyFormat(Number(statData?.impressionsTo).toFixed(), false)}
                          </CardText>
                        </Card>
                      </Col>

                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            Clicks{' '}
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {' '}
                            {statData?.clicks &&
                              setCurrencyFormat(Number(statData?.clicks).toFixed(), false)}
                          </CardText>
                        </Card>
                      </Col>

                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            Orders{' '}
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {' '}
                            {statData?.orders &&
                              setCurrencyFormat(Number(statData?.orders).toFixed(), false)}
                          </CardText>
                        </Card>
                      </Col>

                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            Conversion{' '}
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {statData?.conversion &&
                              `${setCurrencyFormat(
                                Number(statData?.conversion).toFixed(2),
                                false,
                              )} %`}
                          </CardText>
                        </Card>
                      </Col>
                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            ROAS{' '}
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {' '}
                            {statData?.roas &&
                              setCurrencyFormat(Number(statData?.roas).toFixed(2), false)}
                          </CardText>
                        </Card>
                      </Col>
                    </Row>
                    <Row
                      className="justify-content-start align-items-center"
                      style={{ marginTop: '10px' }}
                    >
                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: '#030bfc' }}
                          >
                            Cost
                          </CardTitle>
                          <CardText style={{ color: '#030bfc' }}>
                            {setCurrencyFormat(Number(statData?.cost).toFixed(2), true)}
                          </CardText>
                        </Card>
                      </Col>
                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: '#b30790' }}
                          >
                            Sales{' '}
                          </CardTitle>
                          <CardText style={{ color: '#b30790' }}>
                            {statData?.sales &&
                              setCurrencyFormat(Number(statData?.sales).toFixed(2), true)}
                          </CardText>
                        </Card>
                      </Col>
                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            CPC
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {statData?.cpc &&
                              setCurrencyFormat(Number(statData?.cpc).toFixed(2), true)}
                          </CardText>
                        </Card>
                      </Col>
                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: titleNormalColor }}
                          >
                            CTR{' '}
                          </CardTitle>
                          <CardText style={{ color: titleNormalColor }}>
                            {statData?.ctr &&
                              `${setCurrencyFormat(Number(statData?.ctr).toFixed(2), false)} %`}
                          </CardText>
                        </Card>
                      </Col>

                      <Col sm="6" md="3" lg="2">
                        <Card body>
                          <CardTitle
                            className="bold-text mb-0"
                            tag="h5"
                            style={{ color: '#f6da6e' }}
                          >
                            ACOS
                          </CardTitle>
                          <CardText style={{ color: '#f6da6e' }}>
                            {statData?.acos &&
                              `${setCurrencyFormat(Number(statData?.acos).toFixed(2), false)} %`}
                          </CardText>
                        </Card>
                      </Col>
                    </Row>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Card className="pb-3">
          <CardBody className="">
            <Row className="show-sales-region">
              <Col md="12">
                <Card>
                  <CardBody className="p-0">
                    <div className="top-location" style={{ minHeight: '400' }}>
                      <div>
                        {isLoading ? (
                          <div
                            style={{ minHeight: '200px' }}
                            className="row align-items-center justify-content-center"
                          >
                            <SmallLoader loading={isLoading} />
                          </div>
                        ) : (
                          <AdvCampgains
                            title="ADV Campaign"
                            viewReportButton={viewReportButton}
                            data={advCampaignDataToShowForDatesSelected}
                            dir={rtl.direction}
                          />
                        )}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Card className="pb-3">
          <CardBody className="">
            <Row className="show-sales-region">
              <Col md="12">
                <Card>
                  <CardBody className="p-0">
                    <div className="top-location" style={{ minHeight: '400' }}>
                      <div>
                        {isLoading ? (
                          <div
                            style={{ minHeight: '200px' }}
                            className="row align-items-center justify-content-center"
                          >
                            <SmallLoader loading={isLoading} />
                          </div>
                        ) : (
                          <AdvCampaignTable
                            viewReportButton={viewReportButton}
                            title="ADV Campaign"
                            fileName="ADV Campaign"
                            tableHeaderData={tableAdvCampgains}
                            data={excelData}
                          />
                        )}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
      <ViewNewReturnReportModel
        data={excelData}
        isOpen={isOpen}
        handleModal={setIsOpen}
        title="ADV Campaign"
        fileName="ADV Campaign"
        tableHeaderData={tableAdvCampgains}
      />
    </Container>
  );
};

AdvCampgainsIndex.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
};

export default
  connect(state => ({
    rtl: state.rtl,
  }))(AdvCampgainsIndex)
  ;
